import React, { useContext } from 'react';
import Intl from '@fx-ui/intl';
import { Combo } from '@fx-ui/fine-design';
import { getRequirements, isPersonaFieldAvailable } from '~/utils';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';

/**
 * 你的需求
 */
const Requirement = () => {
    const { personaInfo, setPersonaInfo, personaLabel } = useContext(PersonaContext);
    const { requirement } = personaInfo || {};

    if (!isPersonaFieldAvailable(personaLabel, 'requirement')) {
        return null;
    }

    return (
        <PersonaCollectItem
            className="fx-persona-requirement"
            title={Intl.get('personal.requirement')}
        >
            <Combo
                className="requirement-combo"
                hasSearch={false}
                placeholder={Intl.get('personal.purpose')}
                value={requirement?.value}
                style={{ width: '100%' }}
                items={getRequirements(personaLabel || [])}
                hasClear={false}
                onChange={(_, item: any) => {
                    setPersonaInfo({
                        requirement: item
                    });
                }}
            />
        </PersonaCollectItem>
    );
};

export default Requirement;
